<script>
import { infoMethods, infoDetailsMethods } from '@state/helpers'

export default {
  filters: {
    getColor: function(x) {
      if (x.totalRunningMinutes >= x.totalIdleMinutes) {
        if (x.totalRunningMinutes >= x.totalHoldMinutes) {
          return 'running'
        } else {
          return 'hold'
        }
      } else {
        if (x.totalIdleMinutes >= x.totalHoldMinutes) {
          return 'idle'
        } else {
          return 'hold'
        }
      }
    },

    sqStyle: (x) => {
      let fill = -x.totalRunningMinutes / 3 > 0 ? -x.totalRunningMinutes / 3 > 0 : 1

      return {
        'border-top-width': fill + 'px',
        'border-bottom-width': x.totalRunningMinutes / 3 + 'px',
      }
    },
  },
  props: {
    deviceAggregateHour: {
      type: Array,
      default: () => [],
    },
    startHour: {
      type: Number,
      default: () => 0,
    },
    endHour: {
      type: Number,
      default: () => 0,
    },
  },

  computed: {
    cachedDeviceStateAggregateHourSorted: function() {
      let cachedDeviceStateAggregateHourSorted = this.deviceAggregateHour

      cachedDeviceStateAggregateHourSorted = cachedDeviceStateAggregateHourSorted.filter(
        (obj) => {
          return obj.hour >= this.startHour && obj.hour <= this.endHour
        }
      )

      return cachedDeviceStateAggregateHourSorted
    },
  },

  methods: {
    ...infoMethods,
    ...infoDetailsMethods,

    clickSquare: function(ClickedDeviceAggregateHour) {
      /* this.setInfo({ details: true })
      this.selectDetailsDefault({
        defaultObject: ClickedDeviceAggregateHour,
        detailsType: 'device-state-history',
      })
      toggle(true) */
    },
  },
}
</script>

<template>
  <div class="pl-3 pb-3">
    <div class="pb-1 pl-1 small text-muted">
      <span class="text-uppercase"> Status By Hour of Shift</span>
    </div>
    <div class="box">
      <div
        v-for="n in cachedDeviceStateAggregateHourSorted"
        :key="n.hour"
        class="sqBorder"
      >
        <div
          :style="n | sqStyle"
          class="box-element sqStyle"
          :class="n | getColor"
          @click="clickSquare(n)"
          >{{ n.hour }}
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.condition {
  background-color: #fb4040;
  border-top-color: #fb4040;
  border-top-style: solid;
  border-top-width: 1px;
  border-bottom-color: #06060659;
}
.hold {
  background-color: #f9b115;
  border-top-color: #f9b115;
  border-top-style: solid;
  border-top-width: 1px;
  border-bottom-color: #06060659;
}
.running {
  background-color: #2eb85c;
  border-top-color: #2eb85c;
  border-top-style: solid;
  border-top-width: 1px;
  border-bottom-color: #06060659;
}
.idle {
  background-color: #321fdb;
  border-top-color: #2616b3;
  border-top-style: solid;
  border-top-width: 1px;
  border-bottom-color: #06060659;
}
.gray-1 {
  background-color: #525c67;
  border-top-color: #525c67;
  border-top-style: solid;
  border-top-width: 1px;
  border-bottom-color: #06060659;
}

.sqStyle {
  width: 28px;
  height: 28px;
  display: inline-block;
  text-align: center;
  border-bottom-style: solid;
  line-height: normal;

  font-weight: bolder;
}

.sqBorder {
  width: 30px;
  height: 30px;
  margin: 4px;
  display: inline-block;
  border-radius: 2px;
  text-align: center;
  line-height: normal;
  border: 1px solid #cccccc;
}

.sqBorder:hover {
  transform: scale(2);
}
.box {
  width: 100%;
  padding: 0;
  margin: auto;
  line-height: 0;
  cursor: pointer;
}

.box a {
  margin-left: 5px;
  font-size: 14px;
  color: #73818f;
  text-decoration: none;
}
.box a:hover {
  color: #cccccc;
  text-decoration: none;
}
</style>
